
document.addEventListener('DOMContentLoaded', function() {
  // Get the stored collection URL
  const lastCollection = sessionStorage.getItem('ldrLastCollection');

  if (lastCollection) {
    // Update all continue shopping links
    const continueLinks = document.querySelectorAll('a[href="/pages/shop-by-destination"], a[href="{{ continue_url }}"]');
    continueLinks.forEach(link => {
      link.href = lastCollection;
      console.log('Updated link to:', lastCollection);
    });

    const lastCollectionParam = lastCollection.split('/').pop();
    const lastCollectionParamFinal = lastCollectionParam.replace(/-/g, ' ');
    document.getElementById('last-item-collection').textContent = ': ' + capitalizeFirstLetter(lastCollectionParamFinal);
  }

  const lastShop = sessionStorage.getItem('ldrLastShop');
  if (lastShop) {

    document.getElementById('last-item-shop-link').href = lastShop;
    
    const lastShopParam = lastShop.split('/').pop();
    const lastShopParamFinal = lastShopParam.replace(/-/g, ' ');
    document.getElementById('last-item-shop').textContent = ': ' + capitalizeFirstLetter(lastShopParamFinal);
    
  } else {
    document.getElementById('last-item-shop-link').style.display = "none";
  }
});

function capitalizeFirstLetter(sentence) {
  var returnVal = sentence
    .split(' ') // Split the sentence into an array of words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter and make rest lowercase
    .join(' '); // Join the array back into a sentence
  
  return returnVal.replace(/\busa \b/gi, 'USA ');
}
